var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.70005 6L1.70005 12L0.300049 10.6L4.90005 6L0.300048 1.4L1.70005 -6.11959e-08L7.70005 6Z",
    fill: "#ED1C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrowRight);
export default __webpack_public_path__ + "static/media/redArrowRight.a8bf9d8df2a5476936817e527dd0a472.svg";
export { ForwardRef as ReactComponent };